import page1_img_03_original from "../images/page1-img_03_original.jpg"
import page1_img_03 from "../images/page1-img_03.jpg"
import page1_img_04_original from "../images/page1-img_04_original.jpg"
import page1_img_04 from "../images/page1-img_04.jpg"
import page1_img_05_original from "../images/page1-img_05_original.jpg"
import page1_img_05 from "../images/page1-img_05.jpg"

import img_2 from "../images/gallery/2.jpg"
import img_3 from "../images/gallery/3.jpg"
import img_4 from "../images/gallery/4.jpg"
import img_5 from "../images/gallery/5.jpg"
import img_6 from "../images/gallery/6.jpg"
import img_7 from "../images/gallery/7.jpg"
import img_8 from "../images/gallery/8.jpg"
import img_9 from "../images/gallery/9.jpg"
import img_10 from "../images/gallery/10.jpg"
import img_11 from "../images/gallery/11.jpg"
import img_12 from "../images/gallery/12.jpg"
import img_13 from "../images/gallery/13.jpg"
import img_14 from "../images/gallery/14.jpg"
import img_15 from "../images/gallery/15.jpg"
import img_16 from "../images/gallery/16.jpg"
import img_17 from "../images/gallery/17.jpg"
import img_18 from "../images/gallery/18.jpg"
import img_19 from "../images/gallery/19.jpg"
import img_20 from "../images/gallery/20.jpg"
import img_21 from "../images/gallery/21.jpg"
import img_22 from "../images/gallery/22.jpg"
import img_23 from "../images/gallery/23.jpg"
import img_24 from "../images/gallery/24.jpg"
import img_25 from "../images/gallery/25.jpg"
import img_26 from "../images/gallery/26.jpg"
import img_27 from "../images/gallery/27.jpg"
import img_28 from "../images/gallery/28.jpg"

export const gallery = {
    Gallery:[
        {id: 1, imgFixed: page1_img_03, img: page1_img_03_original},
        {id: 2, imgFixed: page1_img_04, img: page1_img_04_original},
        {id: 3, imgFixed: page1_img_05, img: page1_img_05_original},
        {id: 4, img: img_2},
        {id:5, img: img_3},
        {id:6, img: img_4},
        {id:7, img: img_5},
        {id:8, img: img_6},
        {id:9, img: img_7},
        {id:10, img: img_8},
        {id:11, img: img_9},
        {id:12, img: img_10},
        {id:13, img: img_11},
        {id:14, img: img_12},
        {id:15, img: img_13},
        {id:16, img: img_14},
        {id:17, img: img_15},
        {id:18, img: img_16},
        {id:19, img: img_17},
        {id:20, img: img_18},
        {id:21, img: img_19},
        {id:22, img: img_20},
        {id:23, img: img_21},
        {id:24, img: img_22},
        {id:25, img: img_23},
        {id:26, img: img_24},
        {id:27, img: img_25},
        {id:28, img: img_26},
        {id:29, img: img_27},
        {id:30, img: img_28},
    ],

}

export const Validator = {
        '@NotEmpty': {
            message: 'This field should not be empty.'
        },
}
    